import { AppConfig } from 'config';
import { useEffect } from 'react';

export default function ChatBotWidget() {
  useEffect(() => {
    // :white_check_mark: Load CSS dynamically
    const cssLink = document.createElement('link');
    cssLink.rel = 'stylesheet';
    cssLink.href = '/chatbot-vec/chatbot-widget.css'; // or external URL
    document.head.appendChild(cssLink);
    // :white_check_mark: Load JS dynamically
    const script = document.createElement('script');
    script.src = '/chatbot-vec/chatbot-widget.umd.js'; // or external URL
    script.async = true;
    script.onload = () => {
      if (window.VinhomesChatBot?.setup) {
        window.VinhomesChatBot.setup({
          apiConfig: {
            chatEndpoint: `${AppConfig.endpoint}/stream`,
            historyEndpoint: `${AppConfig.endpoint}/history`,
            username: AppConfig.username || '',
            password: AppConfig.password || '',
          },
          mode: 'real',
          showModeToggle: false,
          title: 'VEC Chatbot',
          welcomeMessage:
            'Xin chào! Tôi là ChatBot VEC. Tôi có thể giúp gì cho bạn?',
          theme: {
            primaryColor: '#E4002B',
            userMessageBg: '#FFE1AD',
            botMessageBg: '#D7E3FE',
            userTextColor: '#475569',
            botTextColor: '#475569',
            borderRadius: '8px',
            fontFamily: 'InterV, Arial, sans-serif',
          },
          titleColor: '#B87400',
          placeholder: 'Đặt câu hỏi của bạn tại đây',
          autoScroll: false,
          position: {
            bottom: '104px',
            right: '76px',
          },
        });
      } else {
        console.error(':x: VinhomesChatBot not found on window.');
      }
    };
    document.body.appendChild(script);
    // :white_check_mark: Cleanup on unmount
    return () => {
      document.head.removeChild(cssLink);
      document.body.removeChild(script);
    };
  }, []);
  return null; // The widget injects its own UI into the DOM
}
